// async function isIncognitoMode() {
//   return new Promise((resolve) => {
//     const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
//     if (!fs) return resolve(false);
//     fs(
//       window.TEMPORARY,
//       100,
//       () => resolve(false),
//       () => resolve(true)
//     );
//   });
// }

function getCookie(name) {
  return (
    document.cookie
      .split("; ")
      .find((v) => v.startsWith(name + "="))
      ?.split("=")[1] || null
  );
}

function getClientId() {
  const key = "clientId";
  let clientId = localStorage.getItem(key);
  if (!!clientId) {
    return clientId;
  }

  const cookieClientId = getCookie(key);
  if (!!cookieClientId) {
    localStorage.setItem(key, cookieClientId);
    return cookieClientId;
  }

  if (crypto.randomUUID) {
    clientId = crypto.randomUUID();
  } else {
    clientId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  localStorage.setItem(key, clientId);
  return clientId;
}

function getCurrency() {
  const key = "currency";
  let currency = localStorage.getItem(key);
  if (!!currency) {
    return currency;
  }

  const cookieCurrency = getCookie(key);
  if (!!cookieCurrency) {
    localStorage.setItem(key, cookieCurrency);
    return cookieCurrency;
  }

  currency = "USD";
  localStorage.setItem(key, currency);
  return currency;
}

export function setCurrency(newCurrency) {
  const key = "currency";
  localStorage.setItem(key, newCurrency);
  document.cookie = `${key}=${encodeURIComponent(newCurrency)}; path=/; max-age=${365 * 24 * 60 * 60}`;

  // if (typeof window === "undefined") return;
  // const host = window.location.hostname;
  // const isLocalhost =
  //   host === "localhost" ||
  //   host === "127.0.0.1" ||
  //   host === "::1" ||
  //   host.endsWith(".localhost");

  // if (!isLocalhost) {
  //   document.cookie = `${key}=${encodeURIComponent(newCurrency)}; path=/; max-age=${365 * 24 * 60 * 60}`;
  // }
}


export function getTabId() {
  const key = "tabId";
  let tabId = sessionStorage.getItem(key);
  if (!!tabId) {
    return tabId;
  }

  if (crypto.randomUUID) {
    tabId = crypto.randomUUID();
  } else {
    tabId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  sessionStorage.setItem(key, tabId);

  return tabId;
}

export function getTimezone() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone;
}


export function getContext() {
  // const key = "context";
  // let context = localStorage.getItem(key);
  // if (!!context) {
  //   return JSON.parse(context);
  // }

  const currency = getCurrency();
  const clientId = getClientId();
  const clientType = "pc";

  const data = {clientId, clientType, currency};

  // localStorage.setItem(key, JSON.stringify(data));

  return data;
}
